module.exports =
  upload: '/internal/fileServer/upload'
  health: '/internal/fileServer/health'
  files:
    base: '/internal/fileServer/files'
    file: '/internal/fileServer/files/:fileName'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/fileServer.coffee